<div class="wrapper-content game-wrapper-full color-1" [style.background]="'url('+'/assets/games/fuego-04.jpg'+')' ">
  <div class="game-header">
    <h5 class="legend">Incendios Forestales</h5>
    <h1 class="title">USUARIO</h1>
    <a class="btn-back" (click)="route.goTo('juego-inicio/incendios')" style="text-decoration: none;">
      <svg xmlns="http://www.w3.org/2000/svg" width="85" height="85" viewBox="0 0 85 85">
        <g id="Grupo_75" data-name="Grupo 75" transform="translate(-1142 -30)">
          <rect id="Rectángulo_145" data-name="Rectángulo 145" width="85" height="85" transform="translate(1142 30)" />
          <g id="Grupo_73" data-name="Grupo 73" transform="translate(1164.95 52.95)">
            <rect id="Rectángulo_3" data-name="Rectángulo 3" width="51" height="5.1"
              transform="translate(0 36.062) rotate(-45)" fill="#fff" />
            <rect id="Rectángulo_141" data-name="Rectángulo 141" width="51" height="5.1"
              transform="translate(3.606 0) rotate(45)" fill="#fff" />
          </g>
        </g>
      </svg>
    </a>
  </div>


  <div class="game-content transparent" style="width:100%">



  </div>



</div>
